'use client';

import { useCallback, useState } from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function MobileMenu() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <div className="md:hidden ml-auto">
      <button className="md:hidden" onClick={toggle} aria-label="Toggle menu">
        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {open && (
        <div className="md:hidden py-4 space-y-4 border-t">
          <Link
            href="/#products"
            className="block text-base font-semibold px-2 py-2 hover:text-primary transition-colors"
            onClick={close}
          >
            Products
          </Link>
          <Link
            href="/#pricing"
            className="block text-base font-semibold px-2 py-2 hover:text-primary transition-colors"
            onClick={close}
          >
            Pricing
          </Link>
          <Link
            href="/blog"
            className="block text-base font-semibold px-2 py-2 hover:text-primary transition-colors"
            onClick={close}
          >
            Blog
          </Link>
          <Link
            href="/news"
            className="block text-base font-semibold px-2 py-2 hover:text-primary transition-colors"
            onClick={close}
          >
            AI Newsletter
          </Link>
          <Link href="/login" onClick={close}>
            <Button variant="default" size="sm" className="w-full">
              Login
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
